import * as C from "../config/constants.js";
import { mergeTierImageUrl } from "../assets/merge-tier-urls.js";
import { collapseTiers } from "./queue-chips.js";

/**
 * @param {HTMLElement} container
 * @param {number[]} tiers flat tier list (e.g. boostBar)
 * @param {{ includeLabel?: boolean, itemsRow?: boolean, labelFirst?: boolean }} [opts]
 */
export function updateStashPanel(container, tiers, opts) {
  if (!container) return;
  opts = opts || {};
  var list = tiers || [];
  var chips = collapseTiers(list, 6);
  var chain = (typeof C.getActiveEvolutionChain === "function")
    ? C.getActiveEvolutionChain()
    : (C.EVOLUTION_CHAIN || []);

  container.innerHTML = "";
  if (opts.includeLabel !== false && opts.labelFirst) {
    var labelFirst = document.createElement("div");
    labelFirst.className = "stash__label";
    labelFirst.textContent = "STASH";
    container.appendChild(labelFirst);
  }
  var itemsParent = container;
  if (opts.itemsRow) {
    itemsParent = document.createElement("div");
    itemsParent.className = "stash__items-row";
    container.appendChild(itemsParent);
  }
  for (var i = 0; i < chips.length; i++) {
    var chip = chips[i];
    var tier = chip.tier;
    var cfg = chain[tier] || {};
    var item = document.createElement("div");
    item.className = "stash__item";
    var img = document.createElement("img");
    img.src = mergeTierImageUrl(cfg.assetId || "cell");
    img.alt = "";
    item.appendChild(img);
    if (chip.count > 1) {
      var badge = document.createElement("span");
      badge.className = "stash__count";
      badge.textContent = "x" + chip.count;
      item.appendChild(badge);
    }
    itemsParent.appendChild(item);
  }
  if (opts.includeLabel !== false && !opts.labelFirst) {
    var label = document.createElement("div");
    label.className = "stash__label";
    label.textContent = "STASH";
    container.appendChild(label);
  }
  container.classList.toggle("stash--empty", chips.length === 0);
}
